import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  isLoading: boolean = false;
  constructor(private loadingController: LoadingController) {}

  async presentLoading(msg: string) {
    this.isLoading = true;
    return await this.loadingController
      .create({
        cssClass: 'my-custom-class',
        message: msg,
      })
      .then((loader) => {
        loader.present().then(() => {
          console.log('presented');
          if (!this.isLoading) {
            loader.dismiss().then(() => console.log('abort presenting'));
          }
        });
      });
  }

  async dismiss() {
    this.isLoading = false;
    return await this.loadingController
      .dismiss()
      .then(() => console.log('dismissed'));
  }
}
